import React, { useState, useCallback, useMemo, useEffect, useContext } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Button, Navbar } from 'react-bootstrap';
import { NavLink, useLocation, useNavigate, Outlet } from 'react-router-dom';
import {
  BiSolidDashboard, BiTimeFive, BiChip, BiBarChartAlt2,
  BiBarChart, BiPulse, BiSolidExtension,
  BiDetail
} from "react-icons/bi";
import { AiOutlineStock } from "react-icons/ai";
import { FiActivity } from 'react-icons/fi';
import {
  MdPowerSettingsNew, MdInsertInvitation, MdMarkunreadMailbox, MdAccountCircle,
  MdList, MdManageAccounts, MdPrecisionManufacturing, MdAssignmentTurnedIn, MdAssessment, MdTrendingUp, MdMoreVert, MdLock
} from "react-icons/md";
import { AiTwotoneProfile } from "react-icons/ai";
import { FaChartBar, FaCogs } from 'react-icons/fa';
import { Tooltip, Menu, MenuItem, IconButton } from '@mui/material';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import logo from '../../assets/yantraimage.png';
import Swal from 'sweetalert2';
import useMobileWidth from './smalldevicesidebar';
import './sidebars.css';
import { SlArrowDown } from "react-icons/sl";
import { GoChevronDown, GoChevronUp } from "react-icons/go";
import { IoSettingsOutline } from "react-icons/io5";
import { IoMdSettings } from "react-icons/io";
import { FaChartLine } from "react-icons/fa";
import { stopTokenAutoRefresh } from '../Services/app/loginservice';
import { UserDetailsContext } from '../Shared/context/UserDetailsContext';
import { TbChecklist, TbFolders, TbLayoutGrid, TbSettings, TbReportAnalytics } from "react-icons/tb";
import ChangePasswordCard from '../Nav/changepassword';
import NotificationBell from '../Pages/NotificationBell/notificationBell';
import { RiNotificationBadgeLine } from "react-icons/ri";
import { FiCheckSquare } from "react-icons/fi";
import { BsGraphUp, BsJustify } from "react-icons/bs";
import { BsKanban, BsList } from "react-icons/bs";
import { MdVerifiedUser, MdRule } from "react-icons/md";
import { cleanCustomerId } from '../Services/app/operatorservice';
import { BsCalendarCheckFill } from "react-icons/bs";
import { useUserRole } from '../Shared/hooks/useUserRole';


const handleConfigurationClick = () => {
  window.open(`${window._env_.SERVER_URL}home`, "_blank");
};

export default function PersistentDrawerLeft({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const [masterOpen, setMasterOpen] = useState(false);
  const [dashboardOpen, setDashboardOpen] = useState(false);
  const [operationOpen, setOperationOpen] = useState(false);
  const [analyticsOpen, setAnalyticsOpen] = useState(false);
  const [productionOpen, setProductionOpen] = useState(false);
  const [qualityOpen, setQualityOpen] = useState(false);
  const [reportsOpen, setReportsOpen] = useState(false);
  const [leaderboardOpen, setLeaderboardOpen] = useState(false);
  const [yantraInternalOpen, setYantraInternalOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [showChangePassword, setShowChangePassword] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const isCssFallback = React.useRef(false);

  const isMobile = useMobileWidth();
  const navigate = useNavigate();
  const location = useLocation();
  const customerId = localStorage.getItem("CustomerID");
  const userRole = JSON.parse(localStorage.getItem("userDetails"));
  const mode = userRole?.mode;
  const normalizedMode = mode?.toLowerCase().replace(/\s+/g, "");
  const { userDetails } = useContext(UserDetailsContext);
  const { isSuperAdmin } = useUserRole();
  const [pageList, setPageList] = useState(userDetails.pageList || []);
  const showReportChildren =
    ["quality", "superadmin", "admin"].includes(normalizedMode) &&
    cleanCustomerId(customerId) === window._env_.CUSTOMER_ID;

  const showReportChildren1 =
    ["superadmin", "admin"].includes(normalizedMode) &&
    cleanCustomerId(customerId) === window._env_.GPLAST_CUSTOMER_ID;


  useEffect(() => {
    const parsed = typeof userDetails === 'string' ? JSON.parse(userDetails) : userDetails;
    setPageList(parsed.pageList || []);
  }, [userDetails]);


  let user = null;
  try {
    user = JSON.parse(localStorage.getItem('authority')) || '';
  } catch (e) {
    user = '';
  }

  const firstName = JSON.parse(localStorage.getItem('firstName') || 'null');
  const lastName = JSON.parse(localStorage.getItem('lastName') || 'null');
  const username = [firstName, lastName].filter(Boolean).join(' ');

  const toggle = useCallback(() => setIsOpen(prev => !prev), []);

  const handleMenuItemClick = (item) => (e) => {
    if (item.name === "Configuration") {
      e.preventDefault();
      handleConfigurationClick();
      if (isMobile) setIsOpen(false);
    } else if (isMobile) {
      setIsOpen(false);
    } else {
      // toggle();
    }
  };

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  // const menuItem = useMemo(() => [
  //   ...(user === "TENANT_ADMIN" ? [{ path: "/configuration", name: "Configuration", icon: <MdManageAccounts /> }] : []),
  //   {
  //     name: "Dashboard",
  //     icon: <BiSolidDashboard />,
  //     children: [
  //       { path: "/company", name: "Company", icon: <BiBarChartAlt2 /> },
  //       { path: "/machinemm", name: "Machine", icon: <IoMdSettings /> },
  //       { path: "/deviceoee", name: "Oee", icon: <FaChartLine style={{ fontSize: "23px" }} /> },
  //     ]
  //   },
  //   // {
  //   //   name: "Analytics",
  //   //   icon: <BiBarChart />,
  //   //   children: [
  //   //     { path: "/analytics", name: "Analytics 1", icon: <BiBarChart /> },
  //   //   ]
  //   // },
  //   // { path: "/report", name: "Reports", icon: <MdAssessment /> },
  //   {
  //     name: "Operation",
  //     icon: <MdPrecisionManufacturing />,
  //     children: [
  //       { path: "/operator-details", name: "Allocation", icon: <MdAssignmentTurnedIn /> },
  //     ]
  //   },
  // {
  //   name: "Analytics",
  //   icon: <BiChip />,
  //   children: [
  //     { path: "/Alarm", name: "Alarms", icon: <BiChip /> },
  //     { path: "/CurrentShift", name: "Current Shift Details", icon: <BiTimeFive /> },
  //   ]
  // },
  //   {
  //     name: "Master",
  //     icon: <MdList />,
  //     children: [
  //       { path: "/machines", name: "Machine", icon: <MdPrecisionManufacturing /> },
  //       { path: "/shift-registration", name: "Shift", icon: <MdInsertInvitation /> },
  //       { path: "/operator-registration", name: "Operator", icon: <MdAccountCircle /> },
  //       { path: "/user-registration", name: "User", icon: <MdAccountCircle /> },
  //       { path: "/component-registration", name: "Component", icon: <MdMarkunreadMailbox /> },
  //       { path: "/reason-registration", name: "Reason", icon: <MdList /> },
  //     ]
  //   },
  // ], [user]);

  const menuItem = useMemo(() => {
    const baseItems = [
      ...(user === "TENANT_ADMIN"
        ? [{ path: "/configuration", name: "Configuration", icon: <MdManageAccounts /> }]
        : []),
      {
        name: "Dashboard",
        icon: <BiSolidDashboard />,
        children: [
          { path: "/kpi-dashboard", name: "KPI", icon: <FaChartBar /> },
          // { path: "/company", name: "Company", icon: <BiBarChartAlt2 /> },
          { path: "/machinemm", name: "Machine", icon: <IoMdSettings /> },
          { path: "/machine-status", name: "Machine Status", icon: <BiPulse /> },
          { path: "/deviceoee", name: "Oee", icon: <FaChartLine style={{ fontSize: "23px" }} /> },
          { path: "/operator-performance", name: <>Operator<br />Performance</>, icon: <BiBarChartAlt2 /> },
        ],
      },
      {
        name: "Production",
        icon: <BsList style={{ fontSize: "20px", color: "black" }} />,
        children: [
          ...(cleanCustomerId(customerId) === window._env_.GPLAST_CUSTOMER_ID ? [{ path: "/production-overview", name: "Overview", icon: <BsKanban style={{ fontSize: "20px", color: "black" }} /> }] : []),
          { path: "/production-metrics", name: "Metrics", icon: <BsGraphUp style={{ fontSize: "20px", color: "black" }} /> },
          { path: "/holiday-list", name: "Holiday Calendar", icon: <BsCalendarCheckFill style={{ fontSize: "18px", color: "black" }} /> }
        ]
      },
      {
        name: "Analytics",
        icon: <BiBarChart />,
        children: [
          { path: "/analytics", name: "Operation", icon: <TbLayoutGrid size={20} /> },
          { path: "/production-analysis", name: "Component", icon: <FaCogs size={18} /> }
        ]
      },
      { path: "/insights", name: "Insights", icon: <BiBarChartAlt2 size={20} /> },
      {
        name: "Leaderboard",
        icon: <BiBarChartAlt2 />,
        children: [
          { path: "/operator-leaderboard", name: "Operator", icon: <TbLayoutGrid size={20} /> }

        ]
      },
      { path: "/erpjson", name: "ERP", icon: <MdAssessment /> },
      {
        name: "Quality",
        icon: <FiCheckSquare size={20} />,
        children: [
          { path: "/bluecard", name: "Blue Card Entry", icon: <MdRule /> },
          { path: "/quality", name: "Quality Entry", icon: <MdVerifiedUser /> },
        ]
      },
      { path: "/erpreport", name: "ERP Planner", icon: <BiBarChartAlt2 size={20} /> },
              
      ...(showReportChildren ?
        [
          {
            name: "Reports",
            icon: <TbReportAnalytics size={22} />,
            children: [
              { path: "/bluecardreport", name: "Blue Card Report", icon: <MdAssignmentTurnedIn /> },
              { path: "/reports", name: "Reports", icon: <MdAssessment /> },
            ],
          },
        ]
        : [
            { path: "/reports", name: "Reports", icon: <MdAssessment /> },
          ]),
      {
        name: "Operation",
        icon: <AiTwotoneProfile />,
        children: [{ path: "/operator-details", name: "Allocation", icon: <MdAssignmentTurnedIn /> }],
      },
      {
        name: "Master",
        icon: <MdList />,
        children: [
          { path: "/machines", name: "Machine", icon: <MdPrecisionManufacturing /> },
          { path: "/machines-group", name: "Machine Group", icon: <FaCogs /> },
          { path: "/shift-registration", name: "Shift", icon: <MdInsertInvitation /> },
          // { path: "/operator-registration", name: "Operator", icon: <MdAccountCircle /> },
          { path: "/user-registration", name: "User", icon: <MdAccountCircle /> },
          { path: "/component-registration", name: "Component", icon: <MdMarkunreadMailbox /> },
          { path: "/reason-registration", name: "Reason", icon: <TbChecklist /> },
          { path: "/group", name: "Group", icon: <TbFolders /> },
          { path: "/settings", name: "Settings", icon: <TbSettings /> },
        ],
      },
      { path: "/erpreportschedule", name: "Email Configuration", icon: <BsCalendarCheckFill size={20} /> },
      { path: "/notification-center", name: "Notification Center", icon: <RiNotificationBadgeLine /> },
      ...(isSuperAdmin
        ? [
            {
              name: "Yantra Internal",
              icon: <BiSolidExtension />,
              children: [
                { path: "/hardware-status", name: "Hardware Status", icon: <BiChip /> },
              ],
            },
          ]
        : []),
    ];
    return baseItems
      .map((item) => {
        if (item.name === "Yantra Internal") {
          return item;
        }
        if (item.children) {
          const allowedChildren = item.children.filter((child) =>
            pageList.includes(child.path.replace("/", ""))
          );
          return allowedChildren.length > 0 ? { ...item, children: allowedChildren } : null;
        }
        if (item.path === "/insights" && isSuperAdmin) return item;
        return pageList.includes(item.path.replace("/", "")) ? item : null;
      })
      .filter(Boolean);
  }, [user, pageList, isSuperAdmin]);


  useEffect(() => {
    console.log("Current active route:", location.pathname);
  }, [location]);

  const toggleFullscreen = useCallback(() => {
    if (isFullscreen) {
      if (isCssFallback.current) {
        isCssFallback.current = false;
        setIsFullscreen(false);
      } else if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    } else {
      const el = document.documentElement;
      if (el.requestFullscreen) {
        el.requestFullscreen().catch(() => {
          isCssFallback.current = true;
          setIsFullscreen(true);
        });
      } else if (el.webkitRequestFullscreen) {
        el.webkitRequestFullscreen();
      } else {
        isCssFallback.current = true;
        setIsFullscreen(true);
      }
    }
  }, [isFullscreen]);

  useEffect(() => {
    const handleFS = () => setIsFullscreen(
      !!document.fullscreenElement || !!document.webkitFullscreenElement
    );
    document.addEventListener('fullscreenchange', handleFS);
    document.addEventListener('webkitfullscreenchange', handleFS);
    return () => {
      document.removeEventListener('fullscreenchange', handleFS);
      document.removeEventListener('webkitfullscreenchange', handleFS);
    };
  }, []);

  useEffect(() => {
    const handleKey = (e) => {
      if ((e.key === 'f' || e.key === 'F') && !e.ctrlKey && !e.altKey && !e.metaKey) {
        const tag = document.activeElement?.tagName;
        if (tag !== 'INPUT' && tag !== 'TEXTAREA' && tag !== 'SELECT') {
          toggleFullscreen();
        }
      }
    };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [toggleFullscreen]);

  const handleLogout = () => {
    Swal.fire({
      title: 'Are you sure want  to logout?',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.isConfirmed) {
        stopTokenAutoRefresh();
        localStorage.clear();
        navigate('/');
      }
    });
  };

  const formattedUser = typeof user === 'string'
    ? user.toLowerCase().replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase())
    : '';

  const renderDropdown = (item, isOpenState, setIsOpenState) => (
    <div key={item.name}>
      <div
        className="link navlink"
        style={{
          textDecoration: 'none',
          color: 'inherit',
          display: 'flex',
          alignItems: 'baseline',
          cursor: 'pointer',
          padding: '8px 12px'
        }}
        onClick={() => setIsOpenState(!isOpenState)}
      >
        <div className="icon">{item.icon}</div>
        {isOpen && (
          <div style={{ marginLeft: '8px' }} className="link_text">
            {item.name} {isOpenState ? <GoChevronUp /> : <GoChevronDown />}
          </div>
        )}
      </div>

      {isOpenState && (
        <div style={{ marginLeft: isOpen ? '30px' : '0' }}>
          {item.children.map((child, idx) => (
            <NavLink
              to={child.path}
              key={idx}
              className={({ isActive }) =>
                isActive ? 'link navlink active' : 'link navlink'
              }
              onClick={handleMenuItemClick(child)}
              style={{
                textDecoration: 'none',
                color: 'inherit',
                display: 'flex',
                alignItems: 'center',
                padding: '6px 12px'
              }}
            >
              <div className="icon">{child.icon}</div>
              {isOpen && (
                <div style={{ marginLeft: '8px' }} className="link_text">
                  {child.name}
                </div>
              )}
            </NavLink>
          ))}
        </div>
      )}
    </div>
  );

  return (
    <>
      <Navbar className="navbar">
        <div className="navbarcontent">
          <Button variant="outline-info" onClick={toggle} style={{ textAlign: 'center', color: 'black' }}>
            <span className="menu-icon">&#9776;</span>
          </Button>
          <img className="Logo" src={logo} alt="Logo" />
          <span style={{ fontWeight: '500', fontSize: '20px' }}></span>
          <div className="rightsidecontents">
            <Tooltip title={isFullscreen ? 'Exit Fullscreen (F)' : 'Fullscreen (F)'}>
              <IconButton onClick={toggleFullscreen} size="small" style={{ color: 'black' }}>
                {isFullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
              </IconButton>
            </Tooltip>
            <NotificationBell />
            <span className="person" style={{
              backgroundColor: 'black',
              color: 'white',
              borderRadius: '50%',
              width: '36px',
              height: '36px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginRight: '15px',
            }}>
              <PersonOutlineIcon style={{ fontSize: '24px' }} />
            </span>
            <div>
              <h6>{username}</h6>
              <p>{mode || formattedUser}</p>
            </div>
            <Tooltip title="Log-out">
              <label className="circles-icon" onClick={handleLogout} style={{ cursor: 'pointer' }}>
                <MdPowerSettingsNew />
              </label>
            </Tooltip>
            {/* <IconButton onClick={handleClick} size="large">
              <MdMoreVert />
            </IconButton>

            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
              <MenuItem
                onClick={() => {
                  setShowChangePassword(true);
                  handleClose();
                }}
              >
                <Tooltip title="Change Password">
                  <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <MdLock style={{ fontSize: '20px' }} />
                    Change Password
                  </span>
                </Tooltip>
              </MenuItem>

              <MenuItem
                onClick={() => {
                  handleLogout();
                  handleClose();
                }}
              >
                <Tooltip title="Log out">
                  <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <MdPowerSettingsNew style={{ fontSize: '20px' }} />
                    Log out
                  </span>
                </Tooltip>
              </MenuItem>
            </Menu>

            {showChangePassword && (
              <ChangePasswordCard onClose={() => setShowChangePassword(false)} />
            )} */}
          </div>
        </div>
      </Navbar>

      <div className={`sidebar ${isOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
        <div className="top_section">
          <br />
          <img className="Logo1" src={logo} alt="Sidebar Logo" />
          <br />
        </div>
        {menuItem.map((item) => (
          item.children ? (
            item.name === "Master" ? renderDropdown(item, masterOpen, setMasterOpen) :
              item.name === "Dashboard" ? renderDropdown(item, dashboardOpen, setDashboardOpen) :
                item.name === "Production" ? renderDropdown(item, productionOpen, setProductionOpen) :
                  item.name === "Quality" ? renderDropdown(item, qualityOpen, setQualityOpen) :
                    item.name === "Reports" ? renderDropdown(item, reportsOpen, setReportsOpen) :
                      item.name === "Operation" ? renderDropdown(item, operationOpen, setOperationOpen) :
                        item.name === "Analytics" ? renderDropdown(item, analyticsOpen, setAnalyticsOpen) :
                          item.name === "Leaderboard" ? renderDropdown(item, leaderboardOpen, setLeaderboardOpen) :
                            item.name === "Yantra Internal" ? renderDropdown(item, yantraInternalOpen, setYantraInternalOpen) :
                              null
          ) : (
            <NavLink
              to={item.path}
              key={item.name}
              className={({ isActive }) =>
                isActive ? 'link navlink active' : 'link navlink'
              }
              onClick={handleMenuItemClick(item)}
              style={{
                textDecoration: 'none',
                color: 'inherit',
                display: 'flex',
                alignItems: 'center',
                padding: '8px 12px'
              }}
            >
              <div className="icon">{item.icon}</div>
              {isOpen && (
                <div style={{ marginLeft: '8px' }} className="link_text">
                  {item.name}
                </div>
              )}
            </NavLink>
          )
        ))}
      </div>

      <main
        className="main-content"
        style={{
          paddingLeft: isOpen
            ? '250px'
            : '85px',
          transition: 'padding-left 0.3s ease'
        }}
      >
        <Outlet />
      </main>
    </>
  );
}
